import { render, staticRenderFns } from "./OrganismBuildingLoader.vue?vue&type=template&id=b01ed58e&scoped=true&"
import script from "./OrganismBuildingLoader.vue?vue&type=script&lang=js&"
export * from "./OrganismBuildingLoader.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBuildingLoader.vue?vue&type=style&index=0&id=b01ed58e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ed58e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsProjectOrganismLoader: require('/app/components/organisms/project/OrganismLoader.vue').default})
